var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDolarPurple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9.098 16.086",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#c5c9f6",
    d: "M14.377,11.56c-2.029-.527-2.681-1.072-2.681-1.921,0-.974.9-1.653,2.413-1.653,1.591,0,2.181.76,2.234,1.877h1.975a3.562,3.562,0,0,0-2.869-3.4V4.5H12.769V6.43c-1.734.375-3.128,1.5-3.128,3.226,0,2.064,1.707,3.092,4.2,3.691,2.234.536,2.681,1.323,2.681,2.154,0,.617-.438,1.6-2.413,1.6-1.841,0-2.565-.822-2.663-1.877H9.48a3.744,3.744,0,0,0,3.289,3.423v1.939H15.45V18.665c1.743-.331,3.128-1.341,3.128-3.173C18.578,12.954,16.406,12.087,14.377,11.56Z",
    transform: "translate(-9.48 -4.5)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDolarPurple);
export default __webpack_public_path__ + "static/media/icon-dolar-purple.9b4fa6704c97138c5e8a9615700bfa57.svg";
export { ForwardRef as ReactComponent };